import React, { Component } from 'react';
import { Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';

import CustomModal from "../../components/Modal/CustomModal";

import { RetirarMateriaDir, NoRetirarMateriaDir } from "../../funciones/EstudiantesFunction";

import DatosMateriaEst from "./DatosMateriaEst";

class EstudiantesRetiroTable extends Component {
    state = { 
        boton: {
            icon: "fa fa-gear",
            text: "Acciones"
        },
        openModalDel: false,
        modalBtn1: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        modalBtn2: {
            icon: "fa fa-times",
            text: "No",
            disabled: false
        },
        openMaterias: false
    }

    modalDel = () => {
        let {data} = this.props;
        let {modalBtn1, openModalDel, modalBtn2} = this.state;

        let nombre2 = data.nombre_2;
        let apellido2 = data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";

        let contenido = () => (
            <React.Fragment>
                <div>¿Deseas <strong className="text-danger"> CONFIRMAR</strong> el retiro de <strong>{`${data.materia_name} SECCION ${data.seccion}`}</strong> de <strong>{`${data.nacionalidad}${data.ci}`} - <span className="text-primary">{`${data.nombre_1} ${nombre2} ${data.apellido_1} ${apellido2}`}</span></strong>?</div>
            </React.Fragment>
        )

        let retirar = () => {
            if (modalBtn1.disabled === true) return null;

            this.setState({
                modalBtn1: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            }, () => {
                RetirarMateriaDir(data.id, "",() => {
                    this.setState({
                        openModalDel: false,
                        modalBtn1: {
                            icon: "fa fa-check",
                            text: "Si",
                            disabled: false
                        }
                    }, () => {
                        this.props.update()
                        toast.info("Se ha procesado correctamente el retiro de la materia del estudiante",{autoClose: 4000});
                    })
                })
            })
        }

        let noRetirar = () => {
            if (modalBtn2.disabled === true) return null;

            this.setState({
                modalBtn2: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            }, () => {
                NoRetirarMateriaDir(data.id, `${data.materia_name} SECCION ${data.seccion}`, () => {
                    this.setState({
                        openModalDel: false,
                        modalBtn2: {
                            icon: "fa fa-times",
                            text: "No",
                            disabled: false
                        }
                    }, () => {
                        this.props.update()
                        toast.info("Se ha cancelado correctamente el retiro de la materia del estudiante",{autoClose: 4000});
                    })
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className={modalBtn2.icon}></i> {modalBtn2.text}</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icon}></i> {modalBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openModalDel}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {retirar}
                funcion2 = {noRetirar}
            />
        );
    }

    modalMaterias = () => {
        let {openMaterias} = this.state;
        let {data} = this.props;
        let nombre2 = data.nombre_2;
        let apellido2 = data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-check"></i> Aceptar</React.Fragment>}
                boton1 = ""
                large = "large"
                isopen =  {openMaterias}
                titulo = {<div className="text-danger" style={{fontSize: 14}}>{`Materias Inscritas de ${data.nombre_1} ${nombre2} ${data.apellido_1} ${apellido2}`}</div>}
                contenido = {<DatosMateriaEst idEst = {data.idEst}/>}      
                funcion2 = {() => {this.setState({openMaterias: false})}}
            />
        );
    }

    render() {
        let {data} = this.props;
        let {boton} = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let nombre2 = data.nombre_2;
        let apellido2 = data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";

        let contenido = () => {
            if (this.props.tipo === "Solicitud")return (
                <Popover bsSize="large" id="Ins">
                    <div className="text-primary" onClick={() => {this.setState({openModalDel: true})}} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-trash"></i> Confirmar Retiro</div>
                    <div className="text-warning" onClick={() => {this.setState({openMaterias: true})}} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-address-book"></i> Retirar Materias</div>
                </Popover>
            )

            return (
                <Popover bsSize="large" id="Ins">
                    <div className="text-warning" onClick={() => {this.setState({openMaterias: true})}} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-address-book"></i> Retirar Materias</div>
                </Popover>
            )
        }

        let materia = () => {
            if (this.props.tipo === "Solicitud") return (
                <div className="custom-alert-warning">
                    MATERIA: <strong>{`${data.materia_name} SECCION ${data.seccion}`}</strong>
                </div>
            )
        }

        return (
            <React.Fragment>
            <tr>
                <td style={styles}>
                    <div><strong>{`${data.nacionalidad}${data.ci}`} - <span className="text-danger">{`${data.nombre_1} ${nombre2} ${data.apellido_1} ${apellido2}`}</span></strong></div>
                    {materia()}
                </td>
                <td style={styles} align="center">{data.carrera_name}</td>
                <td style={styles}>
                    <OverlayTrigger ref="overlay" trigger="focus" placement="right" overlay={contenido()}>
                        <button className="btn btn-primary" style={{borderWidth:1}}><i className={boton.icon}></i> {boton.text}</button>
                    </OverlayTrigger>
                </td>
            </tr>
            {this.modalDel()}
            {this.modalMaterias()}
            </React.Fragment>
        );
    }
}
 
export default EstudiantesRetiroTable;


// WEBPACK FOOTER //
// ./src/views/Registros/EstudiantesRetiroTable.jsx